import { atom } from 'recoil';
import { EHintType } from 'pages/calculation/consts/hint-types.consts';
import { TCheckedType } from 'pages/common/types';

type TInputParameters = {
  length?: string;
  width?: string;
  height?: string;
  layerThickness?: string;
  areaUser?: number;
};

type TSize = {
  height: string;
  width: string;
};

type TDoors = {
  quantity: number | null;
  sizes: TSize[] | null;
};

type TWindows = TDoors;

type TTotal = {
  area: number;
  requiredQuantity: number;
  requiredVolume?: number;
  volume?: number;
};

type TItemSurfaceParams = {
  area: number;
  requiredQuantity: number;
  requiredVolume?: number;
};

type TItem = {
  productId: string;
  characteristics?: Record<string, number>;
  surface: {
    WALL?: TItemSurfaceParams;
    FLOOR?: TItemSurfaceParams;
    CEILING?: TItemSurfaceParams;
  };
  total: TTotal;
  productPageName?: TValueProduct;
  displayedName?: TValueProduct;
  mediaMainPhoto?: TValueProduct;
  salesPriceValueInConsumerUnitValue?: number;
};

type TSurfaceParams = {
  baseSurface: string;
  typeInstallation?: string;
};

type TSurface = {
  WALL?: TSurfaceParams;
  FLOOR?: TSurfaceParams;
  CEILING?: TSurfaceParams;
};

export type TService = {
  name: string;
  priceMin: number;
};

type TValueProduct = {
  value: string[] | null;
};

export type TTotalComplimentaryProduct = {
  requiredQuantity: number;
  onePiece: string | null;
};

type TCharacteristics = {
  ATT_00543: number;
  ATT_00124: number;
};

export type TComplimentaryProductInfo = {
  productId: string;
  characteristics?: TCharacteristics;
  total: TTotalComplimentaryProduct;
  product_page_name: TValueProduct;
  displayedName: TValueProduct;
  mediaMainPhoto: TValueProduct;
  salesPriceValueInConsumerUnitValue: number | null;
};

export type TComplimentaryGroup = {
  groupName: string;
  requiredToBuy: boolean;
  products: TComplimentaryProductInfo[];
};

export type TCalculateData = {
  calculatorId?: string;
  calculatorName?: string;
  inputParameters: TInputParameters;
  doors?: TDoors;
  windows?: TWindows;
  items: TItem[];
  surface: TSurface;
  hints?: EHintType[];
  services: TService[] | [];
  complimentaryProductInfo: TComplimentaryProductInfo[] | [];
  complimentaryProducts?: string[];
  checkedProducts: TCheckedType | [];
  complimentaryGroups: TComplimentaryGroup[];
};

export const dimensionsAtom = atom({
  key: 'dimensions',
  default: {
    inputParameters: {},
    items: [],
    surface: {},
    services: [],
    complimentaryProductInfo: [],
    checkedProducts: [],
    complimentaryGroups: [],
  } as TCalculateData,
});

export const dimensionsFormValues = atom({
  key: 'dimensionFormValues',
  default: {},
});
